export default __webpack_public_path__ + "static/media/background.163397a3.png";